import React, { createContext, useCallback, useEffect, useState } from "react";

import { useGetBusinessUnitsRelatedEntities } from '../hooks/useBusinessUnits';
import { useUserBusinessUnits, useUsers } from "../hooks/useUsers";

const BusinessUnitContext = createContext({
    assignedBusinessUnits: []
});

export const BusinessUnitProvider = ({ children }) => {
    const { userBusinessUnits, refresh: refreshAssignedBusinessUnits } = useUserBusinessUnits();

    const [assignedBusinessUnits, setAssignedBusinessUnits] = useState();
    const [businessUnitsDetails, setBusinessUnitsDetails] = useState([]);

    const { getBusinessUnitsRelatedEntities } = useGetBusinessUnitsRelatedEntities();
    const { getUsers } = useUsers();

    useEffect(() => {
        setAssignedBusinessUnits(userBusinessUnits);
    }, [userBusinessUnits]);

    const getBusinessUnitDetails = useCallback((id) => {
        let businessUnitDetails = businessUnitsDetails[id];
        if (!businessUnitDetails) {
            Promise.all([getBusinessUnitsRelatedEntities(id), getUsers(id)])
                .then((values) => {
                    let relatedEntities = values[0];
                    let users = values[1];
                    setBusinessUnitsDetails(b => (
                        {
                            ...b,
                            [id]: {
                                ...relatedEntities,
                                'users': users,
                            }
                        }));
                });
            return;
        }

        return businessUnitDetails;
    }, [businessUnitsDetails, getBusinessUnitsRelatedEntities, getUsers]);

    // Useful for when we make changes to data that invalidates our prefetched data
    const clearBusinessUnitDetails = useCallback((businessUnitId, siteId = undefined) => {
        if (siteId) {
            const businessUnitsForSite = assignedBusinessUnits.filter(b => b.siteId === siteId);
            setBusinessUnitsDetails(b => (
                {
                    ...b,
                    ...businessUnitsForSite.reduce((acc, key) => ({ ...acc, [key]: undefined }))
                }));
            return;
        }

        if (businessUnitId) {
            setBusinessUnitsDetails(b => (
                {
                    ...b,
                    [businessUnitId]: undefined
                }));
        }
    }, [assignedBusinessUnits]);

    return (
        <BusinessUnitContext.Provider value={{ assignedBusinessUnits, refreshAssignedBusinessUnits, getBusinessUnitDetails, clearBusinessUnitDetails }}>
            {children}
        </BusinessUnitContext.Provider>
    );
};

export default BusinessUnitContext;